import OnBoardingContainer from '../../../components/on-boarding';
import { useOnBoardingStep5 } from '../hooks/useOnBoardingStep5';

export default function OnBoardingStep5() {
  const { response, onClickOnBoardingCompleted } = useOnBoardingStep5();

  return (
    <OnBoardingContainer
      step={4}
      image={response.content?.image?.data?.attributes?.url || ''}
      title={response?.content?.title || ''}
      description={response?.content?.description || ''}
      button={{
        text: response?.content?.button?.text || '',
        onClick: () => onClickOnBoardingCompleted(),
      }}
    />
  );
}
